<template>
  <div class="doctor">
    <div class="first itemWrapper">
      <img src="@/assets/img/doc/1.png" alt="" />
    </div>
    <div class="second itemWrapper">
      <img src="@/assets/img/doc/2.png" alt="" />
    </div>
    <div class="third itemWrapper">
      <img src="@/assets/img/doc/3.png" alt="" />
    </div>
    <div class="fourth itemWrapper">
      <img src="@/assets/img/doc/4.png" alt="" />
    </div>
    <div class="fifth itemWrapper">
      <p>执照公示</p>
      <div class="imgList">
        <img class="mswkzz" @click="imgCheck(1)" :src="mswkzz" alt="" />
        <img class="yxzzz" @click="imgCheck(2)" :src="yxzzz" alt="" />
        <img class="yxzzz" @click="imgCheck(3)" :src="hlwyy" alt="" />
      </div>
    </div>
    <!-- <van-overlay :show="imgState" :lock-scroll="false" @click="imgState = false">
      123
    </van-overlay> -->
    <!-- <img-show class="imgShow" v-if="imgState" :imgString='mswkzz' ></img-show> -->
  </div>
</template>

<script>
import imgShow from '@/components/imgShow'
export default {
  name: 'Doctor',
  components: {
    imgShow
  },
  data () {
    return {
      imgState: true,
      mswkzz: 'https://yxzapp.oss-cn-beijing.aliyuncs.com/mswkZZ.jpg',
      yxzzz: 'https://yxzapp.oss-cn-beijing.aliyuncs.com/yxzZZ.jpg',
      hlwyy: 'https://yxzapp.oss-cn-beijing.aliyuncs.com/hlwyyZZ.jpg'
    }
  },
  methods: {
    imgCheck (index) {
      if (index === 1) {
        this.$emit('getMessage', this.mswkzz)
        this.$emit('getImgState', true)
      } else if (index === 2) {
        this.$emit('getMessage', this.yxzzz)
        this.$emit('getImgState', true)
      } else if (index === 3) {
        this.$emit('getMessage', this.hlwyy)
        this.$emit('getImgState', true)
      }
    }
  }
}
</script>

<style lang='stylus' scoped>
@import '~@/assets/styles/varibles.styl'

.doctor
  .itemWrapper
    width 100%
    display flex
    flex-direction row
    justify-content center
    align-items center

    img
      width 1280px

  .first
    background #F8F8F8
    height 587px

  .second
    background #E9E4DC
    height 1000px

  .third
    background #F8F8F8
    height 1000px

  .fourth
    background #DCD1D1
    height 1000px

  .fifth
    background white
    padding 50px 0
    text-align center
    display flex
    flex-direction column
    justify-content center
    align-items center

    p
      font-size 26px
      margin 30px 0

    .imgList
      img
        width auto !important
        height 200px
        margin 0 30px
        cursor pointer
</style>



// WEBPACK FOOTER //
// src/views/Doctor/Doctor.vue